var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isSubActivity)?_c('hr'):_vm._e(),(_vm.activity.details !== null)?_c('img',{staticClass:"img-responsive",attrs:{"src":_vm.activity.details.image}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }